export const ueepci_item = [
    {
        "nombre": "Informe UEEPCI 2022",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
             "url" : "/interes/Informe UEEPCI 2022.pdf"
    },
        {
        "nombre": "Informe UEEPCI 2023",
        "icono":"DatosContactoUnidad.png",
        "formatos": [
            {
                // "nombre": "Las personas físicas y morales interesadas.",
                // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                // "html": "./Transparencia/htm/a69_f13_SC.htm"
            }
        ],
         "url" : "/interes/Informe UEEPCI 2023.pdf"
        },

        {
          "nombre": "Informe UEEPCI 2024",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Informe UEEPCI 2024.pdf"
         },

          {
          "nombre": "Informe UEEPCI 2025",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/InformeUEEPCI2025.pdf"
         },


        {
          "nombre": "Criterios Actualizados",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Criterios Actualizados.pdf"
         },
         {
          "nombre": "Manifiesto Servidores Públicos",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Manifiesto_PSP.pdf"
         },
         {
          "nombre": "Manifiesto de particulares",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/Manifiesto_PP.pdf"
         },

         {
          "nombre": "Formato para la notificación de las denuncias.",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/InformeUEEPCI2025.pdf"
         },

         
          {
          "nombre": "Formato para Informe Anual",
          "icono":"DatosContactoUnidad.png",
          "formatos": [
               {
                   // "nombre": "Las personas físicas y morales interesadas.",
                   // "xlsx": "./Transparencia/xlsx/a69_f13_SC.xlsx",
                   // "html": "./Transparencia/htm/a69_f13_SC.htm"
                 }
               ],
           "url" : "/interes/FORMATO_2026.xlsx"
         },
	
];